<interview-wrapper [title]="'interviews.Sample Question Title' | translate">
    <div step-content>
        <ol class="ordered-list">
            <li class="list-item">
                {{'interviews.Sample Question Instructions 1' | translate}}
            </li>
            <li class="list-item">
                {{'interviews.Sample Question Instructions 2' | translate}}
            </li>
            <li class="list-item">
                {{'interviews.Sample Question Instructions 3' | translate}}
            </li>
        </ol>
    </div>
    <div step-actions>
        <button type="button" [routerLink]="['../create']" [queryParams]="{ attempt_id: attemptId, practice: true }" class="btn btn_primary">{{'interviews.Practice Question' | translate}}</button>
    </div>
</interview-wrapper>
